import { useState } from 'react'
import { Popover, RingProgress } from '@mantine/core'
import { Link } from 'react-router-dom'

const number = new Intl.NumberFormat('fr-FR')

export default function DashboardComponentsInventory({ inventoryData }) {
    const [opened, setOpened] = useState(false)
    if (!inventoryData?.location) return null

    const total = Number(inventoryData.count_components_tracked) || 0
    const done = Number(inventoryData.inventory_done) || 0
    const soon = Number(inventoryData.inventory_soon_to_do) || 0
    const overdue = Number(inventoryData.inventory_to_do) || 0
    const inventoryUrl = `/components?physical_inventory=with&inventory_cycle_days=with&orderBy=last_inventory_days&orderByDirection=desc&location_id=${inventoryData.location.id}&columns=physical_invlevel,last_inventory_days,last_inventory`
    const sections = [
        { count: done, color: 'var(--color-green-500, #22c55e)', label: 'À jour' },
        { count: soon, color: 'var(--color-yellow-400, #facc15)', label: 'Sous 7 jours' },
        { count: overdue, color: 'var(--color-red-400, #f87171)', label: 'En retard' },
    ]

    return (
        <Popover opened={opened} onChange={setOpened} width={270} position="bottom-start" withinPortal shadow="md" radius="md" transitionProps={{ duration: 0 }}>
            <Popover.Target>
                <Link
                    to={inventoryUrl}
                    onMouseEnter={() => setOpened(true)}
                    onMouseLeave={() => setOpened(false)}
                    onFocus={() => setOpened(true)}
                    onBlur={() => setOpened(false)}
                    className="flex min-w-0 items-center gap-3 rounded-lg p-3 hover:bg-gray-50 focus-visible:outline-2 focus-visible:outline-blue-500 focus-visible:outline-offset-2"
                >
                    <RingProgress
                        className="shrink-0"
                        size={44}
                        thickness={5}
                        sections={total > 0 ? sections.map(({ count, color }) => ({ value: count / total * 100, color })) : []}
                    />
                    <div className="min-w-0 text-sm">
                        <h3 className="truncate text-gray-500" title={inventoryData.location.name}>{inventoryData.location.name}</h3>
                        <p className="mt-0.5 font-medium">
                            {total === 0 ? 'Aucune référence suivie' : overdue > 0 ? `${number.format(overdue)} à recompter` : 'Tout est à jour'}
                        </p>
                    </div>
                </Link>
            </Popover.Target>
            <Popover.Dropdown onMouseEnter={() => setOpened(true)} onMouseLeave={() => setOpened(false)}>
                <dl className="space-y-2 text-sm">
                    {sections.map(({ label, count, color }) => (
                        <div key={label} className="flex items-center justify-between gap-4">
                            <dt className="flex items-center gap-2">
                                <span className="size-2 rounded-full" style={{ backgroundColor: color }} aria-hidden="true" />
                                {label}
                            </dt>
                            <dd className="tabular-nums">{number.format(count)}</dd>
                        </div>
                    ))}
                </dl>
                <div className="mt-3 border-t pt-3 text-xs text-gray-500 space-y-1">
                    <p>{number.format(total)} références suivies</p>
                    <p>{number.format(inventoryData.recommended_inventory_by_week || 0)} à inventorier / semaine</p>
                </div>
            </Popover.Dropdown>
        </Popover>
    )
}
